import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum ActiveStatusEnum {
  未激活 = 0,
  已激活 = 1,
}
export enum UserStatusEnum {
  主态 = 0,
  客态 = 1,
}

// [勋章首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122798098
export const homepage = createAsyncThunk(
  '/live/privilege/medal_homepage_v2',
  async (arg: {mid: number}, store: any) => {
    const resp = await http.post('/live/privilege/medal_homepage_v2', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// [勋章详情] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122799020
export interface IMedalDetail {
  type: 1 | 2 // 1成就勋章（阶段） 2荣誉勋章（非阶段）
  pos: number // 默认展示的下标
  list: Array<
    Partial<{
      name: string
      icon: string
      stars_icon: string
      status: 0 | 1 | 2 // 0 未获得 1 已获得 2 过期
      achieve_text: string
      link: string
      // 1成就勋章（阶段）
      max_score: number
      current_score: number
      small_icon: string
      small_icon_select: string
      achieve_date: string
      // 2荣誉勋章（非阶段）
      duration: number
      from: string
    }>
  >
}
export const get_medal_detail = createAsyncThunk(
  '/live/privilege/get_medal_detail',
  async (
    arg: {
      medal_id: number
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<IMedalDetail>>(
      '/live/privilege/get_medal_detail',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface MedalInfoType {
  id: number
  medal_id: number
  stars: number
  medal_name: string
  icon: string
  status: ActiveStatusEnum
}
export interface InitialStateType {
  home: {
    avatar?: string
    name?: string
    url?: string
    stars?: number
    medal_cnt?: number
    achievement_list?: Array<MedalInfoType>
    honor_list?: Array<MedalInfoType>
    wear_medal?: Array<MedalInfoType>
  }
  base: {
    isEdit: boolean
    userStatus: UserStatusEnum
    selectedMedals: Array<MedalInfoType>
  }
}

const initialState: InitialStateType = {
  home: {},
  base: {
    isEdit: false,
    userStatus: UserStatusEnum.主态,
    selectedMedals: [],
  },
}

export const MedalSlice = createSlice({
  name: 'MedalSlice',
  initialState,
  reducers: {
    updateSelectedMedals: (
      state,
      action: PayloadAction<Array<MedalInfoType>>
    ) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          selectedMedals: action.payload,
        },
      })
    },
    updateEditing: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isEdit: action.payload,
        },
      })
    },
    updateUserStatus: (state, action: PayloadAction<UserStatusEnum>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          userStatus: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      const {base} = state
      const {wear_medal} = action.payload
      Object.assign(state, {
        home: action.payload,
        base: {...base, selectedMedals: wear_medal},
      })
    })
  },
})
export default MedalSlice.reducer
export const MedalActions = MedalSlice.actions

export const useMedalState = () => {
  const data = useSelector((state) => {
    return state.Medal
  })
  return data
}
